export var CreditCardBrands = {
    VISA: 'VISA',
    MA: 'MA',
    AMEX: 'AMEX',
    DISC: 'DISC',
    HDCOM: 'HDCOM',
    HDCON: 'HDCON',
    PROP: 'PROP',
    PROX: 'PROX',
};
export var CreditCardTypes = {
    VISA: 'VI',
    MA: 'MA',
    AMEX: 'AX',
    DISC: 'DS',
    PBA: 'PBA',
    HDCON: 'HC',
};
